import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { IMajorTech } from "../../models/MajorTech";
import { useForm } from 'react-hook-form';
import { yupResolver } from "@hookform/resolvers/yup";
import * as yup from "yup";
import { useEffect, useState } from "react";
import { Fetch } from "../../shared/Fetch";
import { JVInput } from "../../shared/JVInput";

import { JVCheckbox } from "../../shared/JVCheckbox";
import { ITeamsDropdown } from "../../models/IDropdown";
import { JVMultiselect } from "../../shared/JVMultiselect";
import { ILogin, IPermissionProps } from "../../models/Login";
import { EmptyMajorTech } from "./EmptyMajorTech";

const schema = yup.object({
    req_CategoryName: yup.string().required(" Technology is required*"),
    // minimum_Rate:yup.number().typeError("should be a number").required("minimum rate is required").nullable(),
    remote_Rate:yup.number().typeError("should be a number").required("remote rate is required").nullable(),
    onsite_Rate:yup.number().typeError("should be a number").required("onsite rate is required").nullable(),
    lead_Rate:yup.number().typeError("should be a number").required("lead rate is required").nullable(),
    architect_Rate:yup.number().typeError("should be a number").required("architect rate is required").nullable(),

    req_CategoryStatus: yup.boolean().nullable(),
});

interface Iprops {
    singleData: IMajorTech,
    open: boolean,
    hideDialog: () => void,
    toast: any,
    reload: boolean,
    setReload: (is: boolean) => void,
    permissions: IPermissionProps
}

interface IRecruiterListDropdown {
    login_ID: number,
    user_Name: string,
    is_Allocated: number,
}


export const Form = (props: Iprops) => {
    const [teams, setTeams] = useState<Array<ITeamsDropdown>>();
    const [recruiters, setRecruiters] = useState<Array<IRecruiterListDropdown>>();
    const [selectedRecruiters, setSelectedRecruiters] = useState<Array<IRecruiterListDropdown>>();
    const [selectedTeams, setSelectedTeams] = useState<Array<ITeamsDropdown>>();
    const [isTeam, setIsTeam] = useState(false);
    const [isRecruiterAllocation, setIsRecruiterAllocation] = useState(false);
    const [loading, setLoading] = useState(false);
    const [subCategory, setSubCategory] = useState(false);
    const [isAllocation, setIsAllocation] = useState(false);
    const [showRate, setShowRate] = useState<boolean>(false);


    const { control, handleSubmit, formState: { errors }, reset, watch } = useForm<IMajorTech>({
        resolver: yupResolver(schema),
        defaultValues: props.singleData,
        shouldFocusError: false
    });

    let _roles: Array<number> = [];
    const loginObj: ILogin = JSON.parse(sessionStorage.getItem('auth') + '');
    loginObj.roles.forEach(role => {
        _roles.push(role.role_ID);
    });

    const loadRecruiter = async () => {
        // const response = await Fetch("Requirement_CateGoryLInfo/recruiters", "GET", null, null, null);
        // if (response) {
        //     const data: Array<IRecruiterListDropdown> = await response.json();
        //     setRecruiters(data);
        // }

        const response = await Fetch("Requirement_CateGoryLInfo/assignRecruiters", "GET", null, `req_cat_id=${props.singleData.req_CategoryID}`, props.toast);
        if (response) {
            const data: Array<IRecruiterListDropdown> = await response.json();
            let _data: Array<IRecruiterListDropdown> = [];
            setRecruiters(data);
            _data = data.filter((item: IRecruiterListDropdown) => item.is_Allocated === 1);
            setSelectedRecruiters(_data);
        }

    }

    const loadTeams = async () => {
        const response = await Fetch("Dropdown/teams", "GET", null, null, null);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            const _data: Array<ITeamsDropdown> = [];
            data.forEach((item: ITeamsDropdown) => {
                const _item: ITeamsDropdown = {
                    team_ID: item.team_ID,
                    team_Name: item.team_Name
                }
                _data.push(_item);
            });
            setTeams(_data);
        }
    }
    const loadAssignedTeams = async (req_cat_id: number) => {
        const response = await Fetch("Requirement_CateGoryLInfo/teams", "GET", null, `req_cat_id=${req_cat_id}`, props.toast);
        if (response) {
            const data: Array<ITeamsDropdown> = await response.json();
            let _data: Array<ITeamsDropdown> = [];
            data.forEach((item: ITeamsDropdown) => {
                const _item: ITeamsDropdown = {
                    team_ID: item.team_ID,
                    team_Name: item.team_Name
                }
                _data.push(_item);
            });
            setSelectedTeams(_data);

        }
    }

    const loadAssignedRecruiters = async (req_cat_id: number) => {
        // const response = await Fetch("Requirement_CateGoryLInfo/assignRecruiters", "GET", null, `req_cat_id=${req_cat_id}`, props.toast);
        // if (response) {
        //     const data: Array<IRecruiterListDropdown> = await response.json();
        //     const _data: Array<IRecruiterListDropdown> = [];
        //     data.forEach((item: IRecruiterListDropdown) => {
        //         const _item: IRecruiterListDropdown = {
        //             login_ID: item.login_ID,
        //             user_Name: item.user_Name,
        //         }
        //         _data.push(_item);
        //     });
        //     setSelectedRecruiters(_data);
        // }
    }

    useEffect(() => {
        loadTeams();

        if (props.open && props.singleData.req_CategoryID) loadRecruiter();
        if(props.open){
          if(props.singleData.req_CategoryID==31){
            console.log(props.singleData.req_CategoryID)
            setShowRate(true)
        }else{
            setShowRate(false)

        }
    }
    }, [props.open]);
    useEffect(() => {
        reset(props.singleData);
        if (props.singleData.allocateByTeamLead) {
            setIsTeam(true);
            if (props.singleData.req_CategoryID) loadAssignedTeams(props.singleData.req_CategoryID);
        }

        if (props.singleData.recruiterAllocationAuto) {
            setIsRecruiterAllocation(true);
            if (props.singleData.req_CategoryID) loadAssignedRecruiters(props.singleData.req_CategoryID);
        }
        if (props.singleData.sub_Category) {
            setSubCategory(true);
        }
        if(props.singleData.is_Across_Company){
            setIsAllocation(true);
        }
    }, [props.singleData]);
    useEffect(() => {
        const subscription = watch((value, { name, type }) => {
            if (name === "allocateByTeamLead") {
                if (value.allocateByTeamLead === true) setIsTeam(true);
                else setIsTeam(false);
            }
            if (name === "recruiterAllocationAuto") {
                if (value.recruiterAllocationAuto === true) setIsRecruiterAllocation(true);
                else setIsRecruiterAllocation(false);
            }
            if (name === "sub_Category") {
                if (value.sub_Category === true) setSubCategory(true);
                else setSubCategory(false);
            }
            if(name==="is_Across_Company"){
                if(value.is_Across_Company === true) setIsAllocation(true);
                else setIsAllocation(false);
            }
        });
        return () => subscription.unsubscribe();
    }, [watch]);

    interface Teams {
        team_ID: number
    }
    interface Recruiters {
        recruiter_ID: number
    }
    const saveToDB = async (body: IMajorTech) => {
        setLoading(true);
        const method = props.singleData.req_CategoryID ? "PUT" : "POST";
        const message = props.singleData.req_CategoryID ? "Updated Successfully" : "Added Successfully";

        body = { ...body, allocateByRecruiterHead: body.recruiterAllocationAuto ? true : false };
        

        const _teams: Array<Teams> = [];
        const _recruiters: Array<Recruiters> = [];
        selectedTeams?.forEach(team => {
            _teams.push({ team_ID: team.team_ID });
        });
        selectedRecruiters?.forEach(rec => {
            _recruiters.push({ recruiter_ID: rec.login_ID });
        });
        let query: null | string = null;
        if (_teams.length > 0) query = "teams=" + JSON.stringify(_teams);
        if (_recruiters.length > 0) query = "recruiters=" + JSON.stringify(_recruiters);

        if (_roles.includes(4) && _recruiters.length == 0) {
            props.toast.current.show({ severity: 'error', detail: "Please select a recruiter", life: 3000 });
        } else {
            const response = await Fetch("Requirement_CateGoryLInfo", method, body, query, props.toast);
            if (response) {
                props.hideDialog();
                props.toast.current.show({ severity: 'success', detail: message, life: 3000 });
                props.setReload(!props.reload);
                reset(EmptyMajorTech)
                setLoading(false);
            }
        }

        setLoading(false);
        // if (body.allocateByTeamLead && query === null) {
        //     props.toast.current.show({ severity: 'error', detail: "Select at least one Team", life: 3000 });
        // } else if (body.recruiterAllocationAuto && query === null) {
        //     props.toast.current.show({ severity: 'error', detail: "Select at least one Recruiter", life: 3000 });
        // } else {
        // }
    }

    const onHide = () => {
        props.hideDialog();
        reset(EmptyMajorTech);
        setIsTeam(false);
        setSelectedTeams(undefined);
        setSelectedRecruiters(undefined);
        setIsRecruiterAllocation(false);
        setIsTeam(false);
    }

    function onSubmit(data: IMajorTech) {
        saveToDB(data);
    }

    return (
        <Dialog visible={props.open} style={{ width: '80vw' }} header="Add/Edit Technology" modal className="p-fluid" onHide={onHide}>
            <form onSubmit={handleSubmit(onSubmit)} className="p-fluid formgrid grid">
                <JVInput column={3} required label="Major Technology" control={control} name="req_CategoryName" error={errors.req_CategoryName?.message} disabled={_roles.includes(4) ? true : false} />
                <JVInput column={3} required label="Description " control={control} name="req_CategoryDescription" disabled={_roles.includes(4) ? true : false} />
                {/* <JVInput column={3} required label="Minimum Rate" control={control} name="minimum_Rate" error={errors.minimum_Rate?.message}  /> */}
               {!showRate && <JVInput column={3} required label="Remote Rate" control={control} name="remote_Rate" error={errors.remote_Rate?.message}  />}
                {!showRate && <JVInput column={3} required label="Onsite/Hybrid Rate" control={control} name="onsite_Rate" error={errors.onsite_Rate?.message}  />}
                {!showRate && <JVInput column={3} required label="Lead Rate" control={control} name="lead_Rate" error={errors.lead_Rate?.message}  />}
                {!showRate &&<JVInput column={3} required label="Architect Rate" control={control} name="architect_Rate" error={errors.architect_Rate?.message}  />}

               
                {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26)) && <JVCheckbox column={4} control={control} name="req_CategoryStatus" label="Category Status" />}
                {/* { (_roles.includes(1) || _roles.includes(20)|| _roles.includes(26)) && <JVCheckbox column={4} control={control} name="allocateByRecruiterHead" label="AllocateByRecruiterHead" />} */}
                {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26) || _roles.includes(4)) && <JVCheckbox column={4} control={control} name="recruiterAllocationAuto" label="Recruiter Auto Allocation" disabled={_roles.includes(4) ? true : false} />}
                {(_roles.includes(1) || _roles.includes(20) || _roles.includes(26)) && <JVCheckbox column={4} control={control} name="allocateByTeamLead" label="AllocateByTeamLead" />}
                <JVCheckbox column={4} control={control} name="sub_Category" label="Sub Category" />
                <JVCheckbox column={4} control={control} name="is_Across_Company" label="Across Company" />


                {isRecruiterAllocation && _roles.includes(4) && <JVMultiselect column={1} label="Recruiters" options={recruiters} optionLabel="user_Name" placeholder="Select Recruiter" value={selectedRecruiters} onChange={setSelectedRecruiters} />}

                {isTeam && <JVMultiselect column={1} label="Teams" options={teams} optionLabel="team_Name" placeholder="Select Teams" value={selectedTeams} onChange={setSelectedTeams} />}

                <div className="col-12 md:col-12 flex gap-4 justify-content-end">
                    <Button style={{ width: '100px' }} label="SAVE" type="submit"></Button>
                    <Button style={{ width: '100px' }} label="CLOSE" onClick={onHide} type="button" className="p-button-outlined surface-200		"></Button>
                </div>
            </form>
        </Dialog>
    );
}
